import SectionName from '~/constants/new-cars/SectionName';
import {
  type ConfiguratorState,
  isConfiguratorState
} from '~/context/new-cars/configuratorState';

const VALID_SECTION_NAMES = new Set<string>(Object.values(SectionName));

function isSectionName(value: unknown): value is SectionName {
  return typeof value === 'string' && VALID_SECTION_NAMES.has(value);
}

export function buildNewCarsHistoryState(
  entry: ConfiguratorState,
  sectionSequence: SectionName[]
): object {
  const raw = typeof window !== 'undefined' ? window.history.state : null;
  const existing = typeof raw === 'object' && raw !== null ? raw : {};

  return {
    ...existing,
    newCars: entry,
    newCarsSectionSequence: sectionSequence
  };
}

export function readNewCarsHistoryState(): ConfiguratorState | null {
  if (typeof window === 'undefined') return null;

  const candidate = window.history.state?.newCars;

  return isConfiguratorState(candidate) ? candidate : null;
}

export function readNewCarsSectionSequence(): SectionName[] | null {
  if (typeof window === 'undefined') return null;

  const candidate: unknown = window.history.state?.newCarsSectionSequence;

  if (!Array.isArray(candidate) || candidate.length === 0) return null;
  if (!candidate.every(isSectionName)) return null;

  return candidate;
}
